<div class="d-flex align-items-end" style="height: 5.5rem;">
  <div class="loader loader-dark mb-0"></div>
</div>
<ng-content></ng-content>
